import { render, staticRenderFns } from "./PayFailedView.vue?vue&type=template&id=c37d8ac4&scoped=true&"
import script from "./PayFailedView.vue?vue&type=script&lang=js&"
export * from "./PayFailedView.vue?vue&type=script&lang=js&"
import style0 from "./PayFailedView.vue?vue&type=style&index=0&id=c37d8ac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d8ac4",
  null
  
)

export default component.exports